module.exports={CONTACT:"Get in touch with us"};